import React from 'react';
import clsx from 'clsx';
import globalSearchStyles from '../../../../../common/GlobalSearch/GlobalSearch.module.scss';
import SearchResultsGroup from '../../../../../common/GlobalSearch/Components/SearchResultsGroup/SearchResultsGroup';
import { plusPurpleCircle } from '../../../../../assets/hostedassets';
import { GlobalSearchResultGroups } from '../../../../../common/GlobalSearch/useSearchResultFetcher';
import { useVisibilityConfig } from '../../../../../utils/useVisibilityConfig';
import { VISIBILITY_KEYS } from '../../../../../utils/constants/visibilityKeys';

type AddToWatchlistDropdownProps = {
    visible: boolean;
    searchText: string;
    searchResults: GlobalSearchResultGroups | null;
    onSelectAlreadyAdded: (result: any) => void;
    onSelectAddNew: (result: any) => void;
    onFooterAddNew: () => void;
    alreadyAddedTitle?: string;
    addNewTitle?: string;
    footerLabel?: string;
    footerVisible?: boolean;
    footerIconSrc?: string;
    footerAsFirstAddNewRow?: boolean;
    useWideLayout?: boolean;
    wrapperStyle?: React.CSSProperties;
    wrapperClassName?: string;
};

const AddToWatchlistDropdown: React.FC<AddToWatchlistDropdownProps> = ({
    visible,
    searchText,
    searchResults,
    onSelectAlreadyAdded,
    onSelectAddNew,
    onFooterAddNew,
    alreadyAddedTitle = 'Already Added',
    addNewTitle = 'Add New',
    footerLabel,
    footerVisible = true,
    footerIconSrc = plusPurpleCircle,
    footerAsFirstAddNewRow = false,
    useWideLayout = false,
    wrapperStyle,
    wrapperClassName,
}) => {
    const { isVisible } = useVisibilityConfig();
    const canArchive = isVisible(VISIBILITY_KEYS.LEAD.ARCHIVE_ENABLED);

    if (!visible || searchText.length < 3 || !searchResults) {
        return null;
    }

    const baseContainerStyle = useWideLayout
        ? {
              top: 'calc(100% + 0.5rem)',
              maxHeight: '18rem',
              boxShadow: '0px 4px 12px rgba(0,0,0,0.12)',
              zIndex: 5,
          }
        : undefined;

    const showFooter = footerVisible && searchText.length > 0;
    const footerAction = (
        <div
            className={clsx(
                globalSearchStyles.SearchResultFooterAction,
                footerAsFirstAddNewRow && globalSearchStyles.SearchResultAddUsingRow,
            )}
            onMouseDown={onFooterAddNew}
            data-testid={footerAsFirstAddNewRow ? 'add-using-leading-row' : undefined}
        >
            <img src={footerIconSrc} alt="add" className={globalSearchStyles.SearchResultFooterIcon} />
            <span className={globalSearchStyles.SearchResultFooterText}>{footerLabel || `Add new organisation "${searchText}"`}</span>
        </div>
    );

    return (
        <div
            className={
                wrapperClassName || `${globalSearchStyles.SearchResults} ${useWideLayout ? globalSearchStyles.SearchResultsWide : ''}`
            }
            style={{ ...baseContainerStyle, ...wrapperStyle }}
            onMouseDown={(e) => e.stopPropagation()}
            onClick={(e) => e.stopPropagation()}
        >
            <SearchResultsGroup
                title={alreadyAddedTitle}
                results={searchResults.alreadyAdded}
                onSelect={onSelectAlreadyAdded}
                canArchive={canArchive}
            />
            <SearchResultsGroup
                title={addNewTitle}
                results={searchResults.addNew}
                isAddNew
                onSelect={onSelectAddNew}
                canArchive={canArchive}
                leadingRow={footerAsFirstAddNewRow && showFooter ? footerAction : undefined}
            />

            {showFooter && !footerAsFirstAddNewRow && <div className={globalSearchStyles.SearchResultFooter}>{footerAction}</div>}
        </div>
    );
};

export default AddToWatchlistDropdown;
